import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DlButtonModule } from '@thds/components/button';
import { DlSelectModule } from '@thds/components/select';
import { DlPaginator } from './paginator/paginator.component';

@NgModule({
  declarations: [DlPaginator],
  imports: [CommonModule, DlButtonModule, DlSelectModule, FormsModule],
  exports: [DlPaginator],
})
export class DlPaginatorModule {}
